import React from 'react'
import styles from './label.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Label = ({ classes, children, className }) => (
  <span className={classNames(classes.label, className)}>{children}</span>
)

export default injectSheet(styles)(Label)
